import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import "../../../styles/Form.css";
import Select from "react-select";
import { MODE } from "../../../constants/SiteConstants";
import { generateSlug } from "../../../utils/commonFunc";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const API_URL = process.env.REACT_APP_API_URL;

const Customform = ({
  fields = [],
  onSubmit,
  mode,
  initialData = {},
  handleImageChange,
  imagePreviews = [],
  customerImagePreviews = [],
  isGoogleMapLoaded = false,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [landmark, setLandmark] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState({});
  const [slugMessage, setSlugMessage] = useState("");
  const [isSlugUnique, setIsSlugUnique] = useState(null);

  useEffect(() => {
    if (mode === MODE.UPDATE && initialData) {
      setFormData({
        ...initialData,
        productcategory: initialData.productcategory?.map((item) => ({ value: item, label: item })) || [],
        blogcategory: initialData.blogcategory?.map((item) => ({ value: item, label: item })) || [],
      });
    }
  }, [initialData, mode]);

  const fetchServiceOptions = async () => {
    try {
      const response = await axios.get(`${API_URL}/services/getAllServices`);
      const options = response.data.data.flatMap((service) =>
        service.options.map((option) => ({
          value: option,
          label: option,
        }))
      );
      setServiceOptions(options);
    } catch (error) { }
  };

  const fetchCategoryOptions = async (fieldName) => {
    try {
      let response;
      if (fieldName === "blogcategory") {
        response = await axios.get(
          `${API_URL}/blogcategory/getAllblogcategory`
        );
      } else if (fieldName === "productcategory") {
        response = await axios.get(`${API_URL}/productcategory/getAllproductcategories`);
      } else if (fieldName === "Tags") {
        response = await axios.get(`${API_URL}/services/getAllServices`);
      }
      if (response?.data?.data) {
        const options = response.data.data.map((category) => ({
          value: category.name,
          label: category.name,
        }));

        setCategoryOptions((prevOptions) => ({
          ...prevOptions,
          [fieldName]: options,
        }));
      }
    } catch (error) { }
  };

  useEffect(() => {
    fields.forEach((field) => {
      if (field.isMultifield) {
        fetchCategoryOptions(field.name);
      } else if (field.isTagsMultifield) {
        fetchServiceOptions();
      }
    });
  }, [fields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "title" || name === "name") {
      const slug = generateSlug(value);
      setFormData((prevData) => ({
        ...prevData,
        slug,
      }));
      checkSlugUniqueness(slug);
    }

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const checkSlugUniqueness = async (slug) => {
    try {
      const response = await axios.get(`${API_URL}/blogs/getAllBlogs`, {
        params: { slug },
      });

      const existingSlugs = response.data.map((vendor) => vendor.slug);

      if (existingSlugs.includes(slug)) {
        setIsSlugUnique(false);
        setSlugMessage("Slug is not unique, please choose another.");
      } else {
        setIsSlugUnique(true);
        setSlugMessage("Slug is available!");
      }
    } catch (error) {
      console.error("Error checking slug uniqueness", error);
      setIsSlugUnique(null);
    }
  };

  const handleQuillChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleTagsChange = (selectedOptions, fieldName) => {
    const tags = selectedOptions.map((option) => ({
      value: option.value,
      label: option.label,
    }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: tags,
    }));
  };

  const handleDateChange = (date, fieldName) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: date,
    }));
    if (errors[fieldName]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: undefined,
      }));
    }
  };
  const validateForm = () => {
    const formErrors = {};

    fields.forEach((field) => {
      const value = formData[field.name];

      if (field.required && !value) {
        formErrors[field.name] = `${field.label} is required`;
      }

      if (field.name === "description" && value) {
        const strippedValue = value.replace(/<[^>]+>/g, "").trim();
        if (!strippedValue) {
          formErrors[field.name] = "Description is required";
        }
      }


    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() && isSlugUnique !== false) {
      if (landmark.length > 0) {
        const lat = landmark[0]?.geometry?.location.lat() || "";
        const lng = landmark[0]?.geometry?.location.lng() || "";
        const formatted_address = landmark[0]?.formatted_address || "";

        formData.lat = lat;
        formData.lng = lng;
        formData.landmark = formatted_address;
      }
      const transformedData = {
        ...formData,
        blogcategory: formData.blogcategory?.map((item) => item.value) || [],
        productcategory: formData.productcategory?.map((item) => item.value) || [],
      };
      onSubmit(formData);
    }
  };
  const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ 'size': ['small', 'medium', 'large', 'huge'] }],
      [{ 'align': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image', 'video'],
      [{ 'color': [] }, { 'background': [] }],
    ],
  };

  return (
    <form onSubmit={handleSubmit}>
      {fields.map((field) => (
        <div className="mb-4" key={field.name}>
          <label
            htmlFor={field.name}
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            {field.label}
          </label>
          {field.type === "file" ? (
            <>
              <input
                type="file"
                name={field.name}
                onChange={(e) => {
                  if (field.name === "image") {
                    handleImageChange(e);
                  }
                }}
              />

              {field.name === "image" && imagePreviews.length > 0 && (
                <div className="image-previews w-full rounded-md border border-stroke p-3 outline-none file:mr-4 file:rounded file:border-[0.5px] file:border-stroke file:bg-[#EEEEEE] file:py-1 file:px-2.5 file:text-sm">
                  {imagePreviews.map((preview, index) => (
                    <img key={index} src={preview} alt="preview" width={150} height={100} />
                  ))}
                </div>
              )}

            </>
          ) : field.type === "rich-text" ? (
            <ReactQuill
              value={formData[field.name] || ""}
              onChange={(value) => handleQuillChange(field.name, value)}
              placeholder={field.placeholder}
              className="mt-2"
              modules={modules} // Add the toolbar configuration here
            />
            ) : field.type === "textarea" ? (
  <textarea
    className="form-control mt-2 w-full"
    rows="4"
    value={formData[field.name] || ""}
    onChange={(e) =>
      setFormData({ ...formData, [field.name]: e.target.value })
    }
    placeholder={field.placeholder}
  />
          ) : field.isMultifield ? (
            <Select
              isMulti
              value={formData[field.name] || []}
              options={categoryOptions[field.name] || []}
              onChange={(selectedOptions) =>
                handleTagsChange(selectedOptions, field.name)
              }
              placeholder={field.placeholder}
              className="mt-2"
            />
          ) : field.type === "date" ? (
            <DatePicker
              selected={formData[field.name] || null}
              onChange={(date) => handleDateChange(date, field.name)}
              className="mt-2 border rounded-md px-3 py-2 w-full"
              placeholderText={field.placeholder}
            />

          ) : (
            <input
              type={field.type}
              name={field.name}
              value={formData[field.name] || ""}
              onChange={handleChange}
              placeholder={field.placeholder}
              className="mt-2 border rounded-md px-3 py-2 w-full"
            />
          )}
          {field.name === "slug" && slugMessage && (
            <div className={`mt-1 text-sm ${isSlugUnique ? "text-green-600" : "text-red-600"}`}>
              {slugMessage}
            </div>
          )}
          {errors[field.name] && (
            <div className="mt-1 text-red-600">{errors[field.name]}</div>
          )}
        </div>
      ))}
      <button
        type="submit"
        className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
      >
        Submit
      </button>
    </form>
  );
};

export default Customform;
